import cx from 'classnames';
import styles from './ColumnHeaders.module.scss';
import getProps from './ColumnHeaders.props';
import { ColumnHeadersCombinedProps } from './types';
import { useTranslation } from 'react-i18next';
import { Text, TextProps } from 'spindl-shared-components';

const defaultContentTextProps: TextProps = {
  align: 'Left',
  styleType: 'Regular', 
  colour: 'Dark',
  type: 'Body4',
};

const usePresenter = (props: ColumnHeadersCombinedProps): ColumnHeadersCombinedProps => {
  const internalProps = getProps('');
  const { t } = useTranslation();

  return {
    ...props,
    nameHeader: {
      targetProps: {
        ...props.nameHeader?.targetProps,
        ...internalProps.nameHeader,
        className: cx(styles.nameHeader, props.classes?.nameHeader),
        text: {
          value: t('column.name.name'),
        },
      },
    },
    emailHeader: {
      targetProps: {
        ...props.emailHeader?.targetProps,
        ...internalProps.emailHeader,
        className: cx(styles.emailHeader, props.classes?.emailHeader),
        text: {
          value:  t('column.name.email'),
        },
      },
    },
    roleHeader: {
      action: 'hover',
      placement: 'bottom',
      targetProps: {
        ...props.roleHeader?.targetProps,
        ...internalProps.roleHeader,
        className: cx(styles.roleHeader, props.classes?.roleHeader),
        text: {
          value:  t('column.name.role'),
        },
      },
      contentProps: {
        align: 'Center',
        content: <Text 
          {...defaultContentTextProps}
          value={t('tool_tip.role')}
        />,
      },
    },
    loginHeader: {
      action: 'hover',
      placement: 'bottom',
      targetProps: {
        ...props.loginHeader?.targetProps,
        ...internalProps.loginHeader,
        className: cx(styles.loginHeader, props.classes?.loginHeader),
        text: {
          value:  t('column.name.last_login'),
        },
      },
      contentProps: {
        align: 'Center',
        content: <Text 
          {...defaultContentTextProps}
          value={t('tool_tip.last_login')}
        />,
      },
    },
    signupHeader: {
      action: 'hover',
      placement: 'bottom',
      targetProps: {
        ...props.signupHeader?.targetProps,
        ...internalProps.signupHeader,
        className: cx(styles.signupHeader, props.classes?.signupHeader),
        text: {
          value: t('column.name.signup_date'),
        },
      },
      contentProps: {
        align: 'Center',
        content: <Text 
          {...defaultContentTextProps}
          value={t('tool_tip.signup_date')}
        />,
      },
    },
    statusHeader: {
      action: 'hover',
      placement: 'bottom',
      targetProps: {
        ...props.statusHeader?.targetProps,
        ...internalProps.statusHeader,
        className: cx(styles.statusHeader, props.classes?.statusHeader),
        text: {
          value: t('column.name.account_status'),
        },
      },
      contentProps: {
        align: 'Center',
        content: <Text 
          {...defaultContentTextProps}
          value={t('tool_tip.account_status')}
        />,
      },
    },
    emptyHeader: {
      targetProps: {
        ...props.emptyHeader?.targetProps,
        ...internalProps.emptyHeader,
        className: cx(styles.emptyHeader, props.classes?.emptyHeader),
      },
    },
  };
};

export default usePresenter;
